import { isTupleVariantFields } from "./types.js";
import { formatVariantName } from "../variant.js";
export function printSource(model) {
    const out = ["typeDiagram", ""];
    for (const d of model.decls) {
        out.push(...printTargeting(d));
        out.push(printDecl(d));
        out.push("");
    }
    const joined = out.join("\n");
    return collapseTrailingNewlines(joined);
}
function collapseTrailingNewlines(s) {
    let end = s.length;
    while (end > 0 && s.charCodeAt(end - 1) === 10) {
        end -= 1;
    }
    return end === s.length ? s : `${s.slice(0, end)}\n`;
}
function printTargeting(d) {
    const lines = [];
    if (d.targeting?.targets !== undefined) {
        lines.push(`@targets(${d.targeting.targets.join(", ")})`);
    }
    if (d.targeting?.skipTargets !== undefined) {
        lines.push(`@skipTargets(${d.targeting.skipTargets.join(", ")})`);
    }
    return lines;
}
function printDecl(d) {
    const generics = d.generics.length === 0 ? "" : `<${d.generics.join(", ")}>`;
    if (d.kind === "record") {
        const fields = d.fields.map((f) => `  ${f.name}: ${printRef(f.type)}`).join("\n");
        return `type ${d.name}${generics} {\n${fields}\n}`;
    }
    if (d.kind === "union") {
        const variants = d.variants
            .map((v) => {
            const head = formatVariantName(v.name, v.discriminant);
            if (v.fields.length === 0) {
                return `  ${head}`;
            }
            if (isTupleVariantFields(v.fields)) {
                return `  ${head}(${v.fields.map((f) => printRef(f.type)).join(", ")})`;
            }
            const inner = v.fields.map((f) => `${f.name}: ${printRef(f.type)}`).join(", ");
            return `  ${head} { ${inner} }`;
        })
            .join("\n");
        return `${d.untagged === true ? "untagged union" : "union"} ${d.name}${generics} {\n${variants}\n}`;
    }
    return `alias ${d.name}${generics} = ${printRef(d.target)}`;
}
function printRef(t) {
    if (t.args.length === 0) {
        return t.name;
    }
    return `${t.name}<${t.args.map(printRef).join(", ")}>`;
}
//# sourceMappingURL=print.js.map